<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24.776" height="21.507" viewBox="0 0 24.776 21.507">
    <g id="Сгруппировать_4761" data-name="Сгруппировать 4761" transform="translate(0)">
      <path id="Контур_4041" data-name="Контур 4041" d="M-421.877-546.477v-2.775a3.217,3.217,0,0,0-3.209-3.238h-8.749a3.242,3.242,0,0,0-3.238,3.238v2.775h-3.381a1.409,1.409,0,0,0-1.409,1.409v3.063a1.409,1.409,0,0,0,1.409,1.409h.42l1.539,8.458a1.409,1.409,0,0,0,1.386,1.156h15.3a1.409,1.409,0,0,0,1.386-1.157l1.538-8.457h.392a1.409,1.409,0,0,0,1.409-1.409v-3.063a1.409,1.409,0,0,0-1.409-1.409Zm-12.586-2.775a.636.636,0,0,1,.628-.628h8.75a.611.611,0,0,1,.6.628v2.775h-9.977Zm1.949,13.234a.975.975,0,0,1-.974.98.976.976,0,0,1-.974-.98V-541.4a.975.975,0,0,1,.974-.98.975.975,0,0,1,.974.98Zm4.031,0a.975.975,0,0,1-.974.98.976.976,0,0,1-.975-.98V-541.4a.975.975,0,0,1,.975-.98.975.975,0,0,1,.974.98Zm4.031,0a.975.975,0,0,1-.974.98.976.976,0,0,1-.975-.98V-541.4a.975.975,0,0,1,.975-.98.975.975,0,0,1,.974.98Z" transform="translate(441.863 552.49)" fill="#e1cd9d"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconCart',
  }
</script>
